import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Restore content on a component's draft
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestRestoreComponentContent = packet => {
  return {
    type: 'REQUEST_RESTORE_COMPONENT_CONTENT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveRestoreComponentContentSuccess = data => ({
  type: 'RECEIVE_RESTORE_COMPONENT_CONTENT_SUCCESS',
  data
})

export const receiveRestoreComponentContentFail = data => ({
  type: 'RECEIVE_RESTORE_COMPONENT_CONTENT_FAIL',
  data
})

export const tryToRestoreComponentContent = packet => (dispatch, getState) => {

  dispatch(requestRestoreComponentContent(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/components/draft/content/' + packet.component_id + '/restore', {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveRestoreComponentContentSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveRestoreComponentContentFail({errors:e, lastSubmit: packet}));
    })
}
